import { createAction, props } from '@ngrx/store';
import { IShareholder } from '@appShared/interfaces/[Model-based]/shareholder.interface';

const pageLevelEventPrefix = '[Admin Page Action]';

export const loadShareholder = createAction(
  `${pageLevelEventPrefix} Load Shareholder`,
  props<{ id: number }>()
);

export const setSelectedShareholder = createAction(
  `${pageLevelEventPrefix} Set Selected Shareholder`,
  props<{ shareholder: IShareholder }>()
);
